const env = (key) => {
  const value = process.env[key];
  return value?.trim() || undefined;
};

export const getFirebaseWebConfig = () => {
  const apiKey = env("REACT_APP_FIREBASE_API_KEY");
  const authDomain = env("REACT_APP_FIREBASE_AUTH_DOMAIN");
  const projectId = env("REACT_APP_FIREBASE_PROJECT_ID");

  if (!apiKey || !authDomain || !projectId) return null;

  const config = { apiKey, authDomain, projectId };

  const storageBucket = env("REACT_APP_FIREBASE_STORAGE_BUCKET");
  const messagingSenderId = env("REACT_APP_FIREBASE_MESSAGING_SENDER_ID");
  const appId = env("REACT_APP_FIREBASE_APP_ID");
  const measurementId = env("REACT_APP_FIREBASE_MEASUREMENT_ID");

  if (storageBucket) config.storageBucket = storageBucket;
  if (messagingSenderId) config.messagingSenderId = messagingSenderId;
  if (appId) config.appId = appId;
  if (measurementId) config.measurementId = measurementId;

  return config;
};

export const isFirebaseConfigured = () => getFirebaseWebConfig() !== null;
